import Immutable from 'immutable';
import { PageId } from 'records/Page';
import { NewRFIAttachment } from './NewRFIAttachment';

export interface RawNewRFIForwardActivity {
  rfiid: string;
  projectid: string;
  message: string;
  attachments: NewRFIAttachment[];
  pageids: string[];
}

export interface NewRFIForwardActivityData {
  rfiid: string;
  projectid: string;
  message: string;
  attachments: Immutable.List<NewRFIAttachment>;
  pageids: Immutable.Set<PageId>;
}

const defaultValues: NewRFIForwardActivityData = {
  rfiid: '',
  projectid: '',
  message: '',
  attachments: Immutable.List<NewRFIAttachment>(),
  pageids: Immutable.Set<PageId>(),
};

export const NewRFIForwardActivityFactory = Immutable.Record(
  defaultValues,
  'NewRFIForwardActivity'
);

export class NewRFIForwardActivity extends NewRFIForwardActivityFactory {
  static deserialize(
    rawNewRFIForwardActivity: RawNewRFIForwardActivity
  ): NewRFIForwardActivity {
    const attachments = Immutable.List<NewRFIAttachment>(
      rawNewRFIForwardActivity.attachments.map(NewRFIAttachment.deserialize)
    );

    return new NewRFIForwardActivity({
      ...rawNewRFIForwardActivity,
      pageids: Immutable.Set(rawNewRFIForwardActivity.pageids),
      attachments,
    });
  }

  serialize(): RawNewRFIForwardActivity {
    return this.toJS();
  }
}
